<template>
  <div class="card card-body profile-card profile__general-info edit-notifications">
    <EditPublicProfile ref="editPublicProfileModal" />
    <Modal
      v-model:show="isConfirmDelete"
      class="modal-alert profile__modal-paymet-edit"
      @close="isConfirmDelete = false"
    >
      <template v-slot:header>
        <h5 class="modal-title">
          {{ $t('profile.public_profile.delete.title') }}
        </h5>
      </template>
      <div class="">
        <i class="fas fa-trash-alt text-red pointer" /><span class="ml-8">{{ $t('profile.public_profile.delete.confirm') }}</span>
      </div>
      <template v-slot:footer>
        <div class="!tw-flex !tw-justify-end !tw-w-full mt-8 mr-0">
          <button
            class="btn btn-outline-primary btn-sm btn__back"
            @click="isConfirmDelete = false"
          >
            {{ $t('profile.buttons.cancel') }}
          </button>
          <button
            class="btn btn-danger btn-sm ml-16"
            :disabled="isLoading"
            @click="confirmDelete"
          >
            {{ $t('profile.buttons.delete') }}
          </button>
        </div>
      </template>
    </Modal>
    <div class="row">
      <h5 class="card-title !tw-flex !tw-justify-between !tw-items-center !tw-w-full pt-0 mb-12">
        <span>{{ $t('profile.public_profile.title') }}</span>
        <span class="btn-wrapper">
          <button
            v-if="!$_.isEmpty(publicProfileData)"
            class="btn btn-outline-danger btn-sm"
            @click.prevent="handleDelete"
          >{{ $t('profile.buttons.delete') }}</button>
          <button
            class="btn btn-outline-primary btn-sm"
            @click.prevent="handleEdit"
          >{{ $t('profile.buttons.edit') }}</button>
        </span>
      </h5>
    </div>
    <hr>
    <div
      v-if="$_.isEmpty(publicProfileData)"
      class="row"
    >
      <div class="col-12 mt-16 no-data">
        <i class="fas fa-user" />
        <span class="ml-8">{{ $t('profile.public_profile.no_data') }}</span>
      </div>
    </div>
    <div
      v-else
      class="row"
    >
      <div class="mt-16 ui-align-center">
        <MenuItem
          icon="fas fa-user"
          :text="publicProfileData.name"
          :type="$t('profile.public_profile.name')"
          tooltip-placement="top"
        />
      </div>
      <div class="item-container col-12">
        <div
          v-for="(item, index) in publicProfileData.contacts"
          :key="index"
          class="col-12 col-sm-6 pl-0 mt-16"
        >
          <MenuItem
            :icon="$_.get(iconMap, [item.type, 'name'], item.type)"
            :icon-color="$_.get(iconMap, [item.type, 'color'], '#303634')"
            :text="item.value"
            :type="messengerTextById[item.type] || item.type"
            :is-social="true"
            tooltip-placement="top"
          />
        </div>
      </div>
      <div class="mt-16 misc">
        {{ publicProfileData.additional_information }}
      </div>
    </div>
  </div>
</template>

<script>
import MenuItem from '@/components/Form/MenuItem.vue';
import { Modal } from '@/components';
import telegramImg from '@/assets/theme/icon/telegram.svg';
import msTeamsImg from '@/assets/theme/icon/ms-teams.svg';
import EditPublicProfile from './Modal/EditPublicProfile.vue';

export default {
  components: {
    Modal,
    EditPublicProfile,
    MenuItem,
  },
  name: 'PublicProfile',
  props: {
    publicProfileData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isLoading: false,
      isEdit: false,
      isConfirmDelete: false,
      iconMap: {
        email: {
          name: 'fas fa-envelope',
        },
        ms_teams: {
          img: msTeamsImg,
        },
        telegram: {
          img: telegramImg,
        },
      },
    };
  },
  computed: {
    messengers() {
      return this.$store.state.misc.messengers.map((e) => ({
        id: e.id,
        text: e.name,
      })).concat({
        id: '',
        text: this.$t('registration.placeholder_messenger'),
      });
    },
    messengerTextById() {
      return this.$store.state.misc.messengers.reduce((acc, messenger) => {
        acc[messenger.id] = messenger.name;
        return acc;
      }, {});
    },
  },
  mounted() {},
  watch: {},
  methods: {
    handleDelete() {
      this.isConfirmDelete = true;
    },
    confirmDelete() {
      this.isLoading = true;

      this.$api.deletePublicProfile(this.form)
        .then(() => {
          this.$store.dispatch('getProfileData');
          this.isConfirmDelete = false;
          this.$alert.success(this.$t('profile.public_profile.success.deleted'));
        })
        .finally(() => this.isLoading = false);
    },
    handleEdit() {
      this.$refs.editPublicProfileModal.open(this.publicProfileData);
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-wrapper {
  display: flex;
  gap: 8px;

  @media (max-width: 450px) {
    flex-direction: column;
  }
}

.profile-card {
  overflow: hidden;
}

.item-container {
  display: flex;
  flex-wrap: wrap;
}

.no-data {
  font-size: 16px;
  color: #a6b2c4;
  text-align: center;
}

.misc {
  white-space: pre-line;
}
</style>
